import { useState } from "react";
import AssistantConsole from "@/components/admin/assistant/AssistantConsole";
import AssistantLogs from "@/components/admin/assistant/AssistantLogs";

export default function AssistantAdminPanel() {
  const [view, setView] = useState("console"); // "console" | "logs"
  return (
    <div data-testid="assistant-admin-panel">
      {view === "console"
        ? <AssistantConsole onOpenLogs={() => setView("logs")} />
        : <AssistantLogs onBack={() => setView("console")} />}
    </div>
  );
}
